<template>
    <div v-if="userToken" id="menu">
        <div class="menu-burger">
            <button class="menu-button" v-on:click="openMenu">
                <ion-icon name="menu"></ion-icon>
            </button>
        </div>
        <div id="menu-view" :class="menuClass">
            <div class="menu-burger">
                <button class="menu-button" v-on:click="closeMenu">
                    <ion-icon name="close"></ion-icon>
                </button>
            </div>
            <ion-list>
                <ion-item v-on:click="goToRoute('home')">
                    <ion-icon name="home"></ion-icon>
                    <ion-label> Home</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('calls')">
                    <ion-icon name="call"></ion-icon>
                    <ion-label>Calls</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('messages')">
                    <ion-icon name="text"></ion-icon>
                    <ion-label>Messages</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('videos')">
                    <ion-icon name="tv"></ion-icon>
                    <ion-label>Videos</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('gallery')">
                    <ion-icon name="images"></ion-icon>
                    <ion-label>Gallery</ion-label>
                </ion-item>
            </ion-list>
            <ion-list v-if="user.is_creator">
                <ion-item v-on:click="goToRoute('send')">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    <ion-label>Send A Message</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('allmessages')">
                    <ion-icon name="chatbubbles"></ion-icon>
                    <ion-label>My Sent Messages</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('recipients')">
                    <ion-icon name="people"></ion-icon>
                    <ion-label>My Recipients</ion-label>
                </ion-item>
            </ion-list>
            <ion-list>
                <ion-item v-on:click="goToRoute('send')" v-if="!user.is_creator">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    <ion-label>Send A Message</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('profile')">
                    <ion-icon name="person"></ion-icon>
                    <ion-label >My Profile</ion-label>
                </ion-item>
                <ion-item v-on:click="goToRoute('upgrade')">
                    <ion-icon name="card"></ion-icon>
                    <ion-label>Upgrade</ion-label>
                </ion-item>
                <!-- <ion-item v-on:click="goToRoute('policy')">
                    <ion-icon name="document"></ion-icon>
                    <ion-label>Privacy Policy</ion-label>
                </ion-item> -->
                <ion-item v-on:click="openPrivacyPolicy()">
                    <ion-icon name="document"></ion-icon>
                    <ion-label>Privacy Policy</ion-label>
                </ion-item>
                <!-- <ion-item href="https://app.ghostdigitallifegoeson.com/policy.pdf" detail="false">
                    <ion-icon name="document"></ion-icon>
                    <ion-label>Privacy Policy</ion-label>
                </ion-item> -->
                <!-- <a href="https://app.ghostdigitallifegoeson.com/policy.pdf" target="_blank" class="menu-link">
                    <i class="fas fa-file"></i> Privacy Policy
                </a> -->
                <ion-item v-on:click="goToRoute('contact')">
                    <ion-icon name="mail"></ion-icon>
                    <ion-label>Contact Us</ion-label>
                </ion-item>
                <ion-item v-on:click="logout()">
                    <ion-icon name="exit"></ion-icon>
                    <ion-label> Logout</ion-label>
                </ion-item>
            </ion-list>
        </div>
    </div>
</template>
<script>

import {userdetails} from '@/mixins/userdetails';

export default {
    mixins : [userdetails],
    methods: {
        openMenu : function () {
            this.$root.openMenu();
        },
        closeMenu : function () {
            this.$root.closeMenu();
        },
        goToRoute : function (route) {
            this.$router.push({name : route});
            this.$root.closeMenu();
        },
        logout : function () {
            this.$root.logout();
            this.$root.closeMenu();
        },
        openPrivacyPolicy : function () {
            console.log(this.$root.device);
            let url = 'https://app.ghostdigitallifegoeson.com/policy.pdf'
            if (this.$root.device.platform == 'browser') {
                window.open(url);
            } else if (this.$root.device.platform == 'iOS') {
                window.open(url, '_system', 'location=no');
            } else {
                window.open(url, '_system', 'location=no');
            }
        }
    },
    computed : {
        showMenu : function () {
            return this.$root.showMenu;
        },
        menuClass : function () {
            if (this.showMenu === true) {
                return '-visible';
            }
            if (this.showMenu === false) {
                return '-hidden';
            }
            return '';
        }
    }
}
</script>
